import { render } from "./TheWelcome.vue?vue&type=template&id=19bb85cf&ts=true"
import script from "./TheWelcome.vue?vue&type=script&lang=ts"
export * from "./TheWelcome.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__